import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OperationActive } from '../../enum/operation-active.enum';

@Component({
    selector: 'roblex-trading-calculator',
    templateUrl: './trading-calculator.component.html',
    styleUrls: ['./trading-calculator.component.scss'],
})
export class TradingCalculatorComponent implements OnInit {
    /**
     * Input text send of trading calculator component
     */
    @Input() textSend: string = 'Envío';
    /**
     * Input text receive of trading calculator component
     */
    @Input() textReceive: string = 'Recibo';
    /**
     * Input exchange rate used of trading calculator component
     */
    @Input() exchangeRateUsed = 0;
    /**
     * Input previous exchange rate of trading calculator component
     */
    @Input() previousExchangeRate: number;
    /**
     * Input symbol send of trading calculator component
     */
    @Input() symbolSend: string;
    /**
     * Input symbol receive of trading calculator component
     */
    @Input() symbolReceive: string;
    /**
     * Input amount send of trading calculator component
     */
    @Input() amountSend = 0;
    /**
     * Input amount receive of trading calculator component
     */
    @Input() amountReceive = 0;
    /**
     * Input rotate of trading calculator component
     */
    @Input() rotate: boolean;
    /**
     * Input disabled amount send of trading calculator component
     */
    @Input() disabledAmountSend: boolean;
    /**
     * Input disabled amount receive of trading calculator component
     */
    @Input() disabledAmountReceive: boolean;
    /**
     * Input hide change of trading calculator component
     */
    @Input() hideChange: boolean;
    /**
     * Output keyup send of trading calculator component
     */
    @Output() keyupSend: EventEmitter<any> = new EventEmitter();
    /**
     * Output keyup receive of trading calculator component
     */
    @Output() keyupReceive: EventEmitter<any> = new EventEmitter();
    /**
     * Output change currency of trading calculator component
     */
    @Output() changeCurrency: EventEmitter<any> = new EventEmitter();
    /**
     * Timeout  of trading calculator component
     */
    timeout: any;
    /**
     * Interval  of trading calculator component
     */
    interval = 1000;
    /**
     * Creates an instance of trading calculator component.
     */
    constructor() {}
    /**
     * on init
     */
    ngOnInit(): void {}
    /**
     * Determines whether keyup send on
     * @param value string
     */
    onKeyupSend(value: string): void {
        clearTimeout(this.timeout);
        const newValue = +(value.replace(new RegExp(',', 'g'), ''))
        this.timeout = setTimeout(() => {
            if (newValue > 0) {
                this.keyupSend.emit({
                    active: OperationActive.SEND,
                    value: +newValue,
                });
            }
            clearTimeout(this.timeout);
        }, this.interval);
    }
    /**
     * Determines whether keyup receive on
     * @param value string
     */
    onKeyupReceive(value: string): void {
        clearTimeout(this.timeout);
        const newValue = +(value.replace(new RegExp(',', 'g'), ''))
        this.timeout = setTimeout(() => {
            if (newValue > 0) {
                this.keyupReceive.emit({
                    active: OperationActive.RECEIVE,
                    value: +newValue,
                });
            }
            clearTimeout(this.timeout);
        }, this.interval);
    }
    /**
     * Determines whether change currency on
     */
    onChangeCurrency() {
        this.changeCurrency.emit({
            active: OperationActive.SEND,
            symbolSend: this.symbolReceive,
            symbolReceive: this.symbolSend,
            value: +this.amountReceive
        })
    }
}
